export default "__VITE_ASSET__p1VtH0uA1FwflypdhN7QNg__"